import { render, staticRenderFns } from "./Valor.vue?vue&type=template&id=79ba71e3&scoped=true"
import script from "./Valor.vue?vue&type=script&lang=js"
export * from "./Valor.vue?vue&type=script&lang=js"
import style0 from "./Valor.vue?vue&type=style&index=0&id=79ba71e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ba71e3",
  null
  
)

export default component.exports